/* eslint-env browser */

export default function () {
  return {
    url: document.referrer
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@spt-tracking/pulse-event-builders/dist/ejs/origin-defaults-browser.js
// module id = 1190
// module chunks = 0